
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 265"}},[_c('g',{attrs:{"data-name":"Group 261"}},[_c('path',{attrs:{"data-name":"Path 113","d":"M500 112.36C224 112.23.12 335.88 0 611.89a499.79 499.79 0 0082.83 275.78l51.59-29.83 102.15-59L221.65 773l-14.86-25.8-102.2 59a437.1 437.1 0 01-44.06-164.1h118.05v-59.51H60.42a435.9 435.9 0 0144-164.19l102.18 59 14.91-25.75 14.84-25.78-102.1-59a444.67 444.67 0 01120.16-120.18l58.94 102.15 25.81-14.91L365 319.07l-59-102.21a436.11 436.11 0 01164.19-44.05v118.1h59.51v-118.1a437 437 0 01164.19 44L634.8 319l25.83 14.92 25.78 14.86 58.91-102.1a442.7 442.7 0 01120.16 120.14l-102.07 59 14.86 25.8 14.91 25.72 102.15-59a435.3 435.3 0 0144.11 164.18h-118.1v59.52h118.1a436.09 436.09 0 01-44.11 164.18l-102.18-59L778.24 773l-14.86 25.75 102.1 59 51.61 29.88c152.2-230.22 88.91-540.24-141.29-692.44a499.69 499.69 0 00-275.88-82.86z"}})]),_c('g',{attrs:{"data-name":"Group 264"}},[_c('path',{attrs:{"data-name":"Path 114","d":"M582.23 621.61v.82a82.87 82.87 0 11-15-58.43l199.07-37.7 4 15.29 3.78 14.41z"}})])])])
          )
        }
      }
    